<template>
  <div class="row" style="padding-top: 20px; padding-bottom: 20px">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <br />
          <div class="row" v-if="viewflag == 'create'">
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg"></div>
                    <div class="col-lg-4">
                      <card class="card-eprf">
                        <div class="row">
                          <div class="col-lg">
                            <p
                              style="
                                color: #358CCB;
                                font-size: 24px;
                                font-weight: 300;
                              "
                            >
                              PRE-PROCESSING ACTIVITY
                            </p>
                          </div>
                        </div>
                        <br />

                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">
                              Pre-processing Reference No.
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <input
                              type="text"
                              v-model="preprocessingrefno"
                              :class="{ 'custom-input': true }"
                              disabled
                            />
                          </div>
                        </div>
                        <br v-if="positionid == 1" />
                        <div class="row" v-if="positionid == 1">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">Service Location</p>
                          </div>
                        </div>
                        <div class="row" v-if="positionid == 1">
                          <div class="col-lg">
                            <el-select
                              class="select-info tab select-width"
                              placeholder="Select Service Location"
                              v-model="servicelocation"
                              style="
                                width: 100%;
                                border-bottom: 1px solid lightgray;
                              "
                              filterable
                            >
                              <el-option
                                v-for="option in servicelocations"
                                class="select-info"
                                :value="option.value"
                                :label="option.label"
                                :key="option.value"
                              ></el-option>
                            </el-select>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">Input Type</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <el-select
                              class="select-info tab select-width eprf-custom-option"
                              placeholder="Select Input Type"
                              v-model="inputtype"
                              style="
                                width: 100%;
                                border-bottom: 1px solid lightgray;
                              "
                              filterable
                              id="eprf-custom-option"
                            >
                              <el-option
                                v-for="(option, index) in inputtypes"
                                :key="index"
                                :value="option.value"
                                :label="option.label"
                              >
                              
                                <div
                                  
                                  style="
                                  
                                    text-overflow: ellipsis;
                                    height: 40px;
                                    width: 450px;
                                    color: #5a5a5a;
                                    font-size: 15px;
                                    font-weight: 400;
                                    overflow:hidden;
                                    white-space:nowrap
                                  "
                                >
                                  {{ option.label }}
                          </div>
                                
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">
                              Quantity to be Processed (in MT)
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <input
                              type="number"
                              :min="0"
                              v-model="quantitytobeprocessed"
                              :class="{ 'custom-input': true }"
                              @input="checkQuantity"
                            />
                            <span
                              v-if="zerochecker"
                              style="color: #EC1B23; font-size: 10px"
                              >Quantity must be greater than zero.</span
                            >
                            <p style="color: #EC1B23; font-size: 10px">
                              Can be filled up to {{ totalqty }} MT
                            </p>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">Waste Line</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <el-select
                              class="select-info tab select-width"
                              placeholder="Select Waste Line"
                              v-model="wasteline"
                              style="
                                width: 100%;
                                border-bottom: 1px solid lightgray;
                              "
                              filterable
                            >
                              <el-option
                                v-for="option in wastelines"
                                class="select-info"
                                :value="option.value"
                                :label="option.label"
                                :key="option.value"
                              ></el-option>
                            </el-select>
                          </div>
                        </div>
                      </card>
                    </div>
                    <div class="col-lg"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg text-right">
                  <base-button
                    wide
                    type="danger"
                    @click.native="getBack()"
                    class="btn-previous"
                  >
                    Cancel
                  </base-button>
                  <base-button
                    v-if="$route.params.action == 'add'"
                    type="primary"
                    wide
                    @click="done('create')"
                    class="btn-primary"

                  >
                    Submit
                  </base-button>
                </div>
              </div>
              <div class="row">
                <div class="col-lg text-right">
                  <p style="color: #EC1B23">{{ errormsg }}</p>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-lg text-right">
                  <p
                    style="
                      color: #052d72;
                      cursor: pointer;
                      text-decoration: underline;
                    "
                    @click="saveDraft()"
                  >
                    Save Draft
                  </p>
                </div>
              </div> -->
            </div>
          </div>
          <div class="row" v-if="viewflag == 'view'">
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg"></div>
                    <div class="col-lg-4">
                      <card class="card-eprf" style="height: 645px">
                        <div class="row">
                          <div class="col-lg">
                            <p
                              style="
                                color: #358CCB;
                                font-size: 24px;
                                font-weight: 300;
                              "
                            >
                              PRE-PROCESSING ACTIVITY
                            </p>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">
                              Pre-processing Reference No.
                            </p>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg">
                            <p class="subtitle">
                              {{ preprocessingrefno }}
                            </p>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">Input Type</p>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg">
                            <p class="subtitle">
                              {{ inputtype }}
                            </p>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">
                              Quantity to be Processed (in MT)
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p class="subtitle">
                              {{ quantitytobeprocessed }}
                            </p>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">Waste Line</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p class="subtitle">
                              {{ wasteline }}
                            </p>
                          </div>
                        </div>
                      </card>
                    </div>
                    <div class="col-lg-4">
                      <card class="card-eprf" style="height: 645px">
                        <div class="row">
                          <div class="col-lg">
                            <p
                              style="
                                color: #358CCB;
                                font-size: 24px;
                                font-weight: 300;
                              "
                            >
                              POST-PROCESSING
                            </p>
                          </div>
                        </div>

                        <div
                          style="
                            height: 550px;
                            overflow: scroll;
                            overflow-x: hidden;
                          "
                        >
                          <b-card
                            class="card"
                            border-variant="primary"
                            header-bg-variant="primary"
                            header-text-variant="white"
                            style="
                              box-shadow: 0px 0px;
                              border: none;
                              width: 100%;
                              background-color: #f5f6fa;
                            "
                            v-for="(card, index) in outputs"
                            :key="index"
                          >
                            <template #header>
                              <div class="row">
                                <div class="col-lg-6">
                                  <h4>OUTPUT - {{ index + 1 }}</h4>
                                </div>
                              </div>
                            </template>
                            <div style="background-color: #f5f6fa">
                              <p style="color: #A5A5A5">Output Type</p>
                              <p class="subtitle">
                                {{ card.outputType }}
                              </p>
                              <p
                                class="new-title"
                                style="padding-top: 50px; color: #A5A5A5"
                              >
                                Quantity Produced
                              </p>
                              <p class="subtitle">
                                {{ card.quantityProduced }}
                              </p>
                            </div>
                          </b-card>
                          <br />
                        </div>
                      </card>
                    </div>
                    <div class="col-lg"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg text-right">
                  <base-button
                    wide
                    type="danger"
                    @click.native="getBack()"
                    class="btn-previous"
                  >
                    Back
                  </base-button>
                  <!-- <base-button v-if="$route.params.action == 'add'" type="primary" wide @click="done('create')"
                    class="btn-next">
                    Submit
                  </base-button> -->
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-lg text-right">
                  <p
                    style="
                      color: #052d72;
                      cursor: pointer;
                      text-decoration: underline;
                    "
                    @click="saveDraft()"
                  >
                    Save Draft
                  </p>
                </div>
              </div> -->
            </div>
          </div>
          <div class="row" v-if="viewflag == 'output'">
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg"></div>

                    <div class="col-lg-4">
                      <card class="card-eprf" style="height: 645px">
                        <div class="row">
                          <div class="col-lg">
                            <p
                              style="
                                color: #358CCB;
                                font-size: 24px;
                                font-weight: 300;
                              "
                            >
                              PRE-PROCESSING ACTIVITY
                            </p>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">
                              Pre-processing Reference No.
                            </p>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg">
                            <p class="subtitle">
                              {{ preprocessingrefno }}
                            </p>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">Input Type</p>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg">
                            <p class="subtitle">
                              {{ inputtype }}
                            </p>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">Quantity to be Processed</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p class="subtitle">
                              {{ quantitytobeprocessed }}
                            </p>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col-lg">
                            <p style="color: #A5A5A5">Waste Line</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p class="subtitle">
                              {{ wasteline }}
                            </p>
                          </div>
                        </div>
                      </card>
                    </div>
                    <div class="col-lg-4">
                      <card class="card-eprf" style="height: 645px">
                        <div class="row">
                          <div class="col-lg">
                            <p
                              style="
                                color: #358CCB;
                                font-size: 24px;
                                font-weight: 300;
                              "
                            >
                              POST-PROCESSING
                            </p>
                          </div>
                        </div>

                        <div
                          style="
                            height: 520px;
                            overflow: scroll;
                            overflow-x: hidden;
                          "
                        >
                          <b-card
                            class="card"
                            border-variant="primary"
                            header-bg-variant="primary"
                            header-text-variant="white"
                            style="
                              box-shadow: 0px 0px;
                              border: none;
                              width: 100%;
                              background-color: #f5f6fa;
                            "
                            v-for="(card, index) in outputs"
                            :key="index"
                          >
                            <template #header>
                              <div class="row">
                                <div class="col-lg-6">
                                  <h4>OUTPUT - {{ index + 1 }}</h4>
                                </div>
                                <div
                                  class="col-lg text-right"
                                  v-if="index > 0"
                                  style="padding: none"
                                >
                                  <base-button
                                    class="btn-icon btn-round btn-cancel btn-sm"
                                    @click="removerow(index)"
                                  >
                                    <i class="tim-icons icon-simple-remove"></i>
                                  </base-button>
                                </div>
                              </div>
                            </template>
                            <div style="background-color: #f5f6fa">
                              <p style="color: #A5A5A5">Output Type</p>
                              <el-select
                                class="select-info tab select-width"
                                placeholder="Select Input Type"
                                v-model="card.outputtype"
                                style="
                                  width: 100%;
                                  border-bottom: 1px solid lightgray;
                                "
                                filterable
                              >
                                <el-option
                                  v-for="option in outputtypes"
                                  class="select-info"
                                  :value="option.value"
                                  :label="option.label"
                                  style="width: 300px"
                                  :key="option.value"
                                ></el-option>
                              </el-select>

                              <p
                                class="new-title"
                                style="padding-top: 50px; color: #A5A5A5"
                              >
                                Quantity Produced
                              </p>
                              <input
                                @input="checkQuantity"
                                type="number"
                                :min="0"
                                v-model="card.quantityProduced"
                                :class="{ 'custom-input': true }"
                              />
                              <span
                                v-if="zerochecker"
                                style="color: #EC1B23; font-size: 10px"
                                >Quantity must be greater than zero.</span
                              >
                            </div>
                          </b-card>
                          <br />
                        </div>
                        <div>
                          <p
                            v-if="addoutputflag"
                            style="
                              color: #052d72;
                              cursor: pointer;
                              text-decoration: underline;
                            "
                            @click="addOutput()"
                          >
                            + Add Output
                          </p>
                        </div>
                      </card>
                    </div>
                    <div class="col-lg"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg text-right">
                      <base-button
                        wide
                        type="danger"
                        @click.native="getBack()"
                        class="btn-previous"
                      >
                        Cancel
                      </base-button>
                      <base-button
                        v-if="showaddoutput"
                        type="primary"
                        wide
                        @click="done('output')"
                        class="btn-primary"
                      >
                        Submit
                      </base-button>
                      <base-button
                        v-if="!showaddoutput"
                        type="danger"
                        wide
                        class="btn-primary"
                      >
                        Submit
                      </base-button>
                    </div>
                  </div>
                  <div class="row">
                <div class="col-lg text-right">
                  <p style="color: #EC1B23">{{ errormsg }}</p>
                </div>
              </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="viewflag == 'qr'">
            <div class="col-lg">
              <div class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg"></div>
                    <div class="col-lg-4">
                      <card class="card-eprf">
                        <p
                          style="
                            color: #358CCB;
                            font-size: 24px;
                            font-weight: 300;
                          "
                        >
                          GENERATE QR CODE
                        </p>
                        <div
                          style="
                            height: 520px;
                            overflow: auto;
                            overflow-x: hidden;
                          "
                        >
                          <b-card
                            class="card"
                            border-variant="primary"
                            header-bg-variant="primary"
                            header-text-variant="white"
                            style="
                              box-shadow: 0px 0px;
                              border: none;
                              width: 100%;
                              background-color: #f5f6fa;
                            "
                            v-for="(card, index) in qrs"
                            :key="index"
                          >
                            <template #header>
                              <h4 class="mb-0">OUTPUT - {{ index + 1 }}</h4>
                            </template>
                            <div style="background-color: #f5f6fa">
                              <div class="row">
                                <div class="col-lg">
                                  <p
                                    class=""
                                    style="color: #A5A5A5; font-weight: 600"
                                  >
                                    {{ card.wastetype }}
                                  </p>
                                </div>
                                <div class="col-lg-1 text-right">
                                  <p @click="download()">
                                    <i
                                      class="fa fa-download text-primary"
                                      aria-hidden="true"
                                    ></i>
                                  </p>
                                </div>
                                <div class="col-lg-1 text-right">
                                  <p @click="print()">
                                    <i
                                      class="fa fa-print text-primary"
                                      aria-hidden="true"
                                    ></i>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </b-card>
                          <br />
                        </div>
                      </card>
                    </div>
                    <div class="col-lg"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg text-right">
                      <base-button
                        wide
                        type="danger"
                        @click.native="getBack()"
                        class="btn-previous"
                      >
                        Cancel
                      </base-button>
                      <base-button
                        type="primary"
                        wide
                        @click="done('output')"
                        class="btn-primary"
                      >
                        Submit
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal :show.sync="modals.successModal">
        <div
          class="modal-header"
          style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #15cf79;
          "
        >
          <div class="col-lg"></div>
          <div class="col-lg-5">
            <div
              style="
                padding: 15px;
                background-color: transparent;
                border-radius: 100px;
                border: 10px solid white;
              "
            >
              <i
                style="color: white; font-size: 90px; font-weight: 900"
                class="tim-icons icon-check-2"
              ></i>
            </div>
            <div>
              <p
                style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                Successful
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p
            style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #707070;
            "
          >
            Congratulations!
          </p>

          <p style="color: #A5A5A5">{{ message }}</p>

          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="primary" v-on:click="modals.successModal = false"
              >Continue</base-button
            >
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.failedModal">
        <div
          class="modal-header"
          style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #EC1B23;
            text-align: center;
          "
        >
          <!-- <div class="col-lg"></div> -->
          <div class="col-lg-12">
            <div>
              <i
                style="color: white; font-size: 120px; font-weight: 900"
                class="tim-icons icon-alert-circle-exc"
              ></i>
            </div>
            <div>
              <p
                style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                Failed
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p
            style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #707070;
            "
          >
            Warning!
          </p>

          <p style="color: #A5A5A5">{{ message }}</p>

          <!-- <p style="color: #A5A5A5; margin-top: 20px">Click 'Retry' to go back.</p> -->
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="danger" v-on:click="modals.failedModal = false"
              >Cancel</base-button
            >&nbsp;
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.done" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>PRE-PROCESSING COMPLETED</h1>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import Card from "../../../../../components/Cards/Card.vue";
import { BCard } from "bootstrap-vue";
import { Modal, ImageUpload } from "../../../../../../src/components";
import { Select, Option } from "element-ui";

export default {
  name: "JobPage1",
  components: {
    Card,
    BCard,
    Modal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      addoutputflag: false,
      showaddoutput: true,
      totalquantityproduced: 0,
      totalqty: 0,
      errormsg: "",
      outputs: [
        {
          id: 0,
          quantityProduced: "",
          outputType: "",
        },
      ],
      qrs: [
        {
          qrid: 0,
          wastetype: "Recon Oil",
          refno: "NVJ456455248",
        },
        {
          qrid: 0,
          wastetype: "Water",
          refno: "NVJ456455248",
        },
      ],
      preprocessingrefno: "",
      quantitytobeprocessed: "",
      wasteline: "",
      wastelines: [
        {
          label: "waste line A",
          value: "waste line A",
        },
        {
          label: "waste line B",
          value: "waste line B",
        },
      ],
      servicelocation: "",
      servicelocations: [],
      inputtype: "",
      inputtypes: [],
      outputtype: "",
      outputtypes: [],
      viewflag: "",
      modals: {
        done: false,
        successModal: false,
        failedModal: false,
      },
      message: "",
      tajuk: "hehasdksdksade",
      selectedFileName: "",
      allfilename: [],

      selectedOption: "option1",
      jobreferenceno: "",
      companyname: "",
      operationtype: "",
      companyaddress: "",
      phoneno: "",
      faxno: "",

      wastegeneration: "",
      landweightin: "",
      vesselweightin: "",
      weightout: "",
      landnetweight: "",
      vesselnetweight: "",
      landweightreceipt: "",
      vesselweightreceipt: "",

      cards: [],
      wastes: [{}],
      wastesvessel: [{}],

      zerochecker: false,

      // wastevehicleno: [],
      // wasteic: [],

      cardWasteVesselCount: 0,
      cardWasteCount: 0,

      //dalam card land
      wastecode: [],
      solidwastetype: [],
      landphreading: [],
      landtemperature: [],
      landwasteline: [],
      landhandlingmethod: [],
      landwastelocationstatus: [],

      //dalam card vessel
      wastetype: [],
      vesselphreading: [],
      vesseltemperature: [],
      vesselwasteline: [],
      vesselhandlingmethod: [],
      vesselwastelocationstatus: [],

      selects: {
        wasteline: "",
        wastelines: [
          { value: 1, label: "Line A - Liquid Mixture" },
          { value: 2, label: "Line B - Slurry Liquid" },
          { value: 3, label: "Line C - Aqueous Waste" },
        ],

        handlingmethod: "",
        handlingmethods: [
          { value: 1, label: "Landfill Dump" },
          { value: 2, label: "Recycling" },
          { value: 3, label: "Waste to Energy" },
          { value: 4, label: "Composting" },
          { value: 5, label: "Thermal Treatment" },
        ],
        wastelocationstatus: "",
        wastelocationstatuss: [
          { value: 1, label: "In PRF" },
          { value: 2, label: "Disposed to Prescribed Premise" },
        ],
      },

      docs: "",
      document: 0,

      documentID: [],
      positionid: "",
    };
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    this.getInputType();
    this.getWasteLine();
    this.getOutputType();
    this.getServiceLocation();
    console.log(this.$route.params)
    this.viewflag = this.$route.params.pagename;
    console.log(this.viewflag);
    this.preprocessingrefno = this.$route.params.refno;

    if (this.viewflag == "create") {
    }
    if (this.viewflag == "output") {
      this.getData();
    }
    if (this.viewflag == "view") {
      this.getSubmittedData();
    }
  },
  methods: {
    getServiceLocation() {
      this.servicelocations = [];

      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };
            this.servicelocations.push(obj);
          }
        }
      });
    },
    checkQuantity(event) {
      let value = parseInt(event.target.value, 10);
      if (value <= 0) {
        // this.quantitytobeprocessed = '';
        this.zerochecker = true;
      } else {
        // this.quantitytobeprocessed = value;
        this.zerochecker = false;
      }
    },
    removerow(index) {
      this.outputs.splice(index, 1);
    },
    getOutputType() {
      this.outputtypes = [];

      this.$http.get(":10001/api/v1/preprocessing/output").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].waste_type_id,
            };

            this.outputtypes.push(obj);
          }
        }
      });
    },
    getData() {
      this.$http
        .get(":10001/api/v1/preprocessing/" + this.preprocessingrefno)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.quantitytobeprocessed = response.input_quantity;

            // this.wasteline = response.assigned_line_id;
            this.wasteline = response.assigned_line;

            // this.inputtype = response.input_type_id;
            this.inputtype = response.name;
          }
        });
    },
    getSubmittedData() {
      this.outputs = [];
      this.$http
        .get(":10001/api/v1/preprocessing/" + this.preprocessingrefno)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.quantitytobeprocessed = response.input_quantity;

            // this.wasteline = response.assigned_line_id;
            this.wasteline = response.assigned_line;

            // this.inputtype = response.input_type_id;
            this.inputtype = response.name;

            for (var i = 0; i < response.waste_output.length; i++) {
              var data = {
                id: i,
                quantityProduced: response.waste_output[i].quantity,
                outputType: response.waste_output[i].name,
              };
              this.outputs.push(data);
            }
          }
        });
    },
    getWasteLine() {
      this.wastelines = [];

      this.$http.get(":10001/api/v1/reference/waste_line").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].waste_line_name,
              value: response[i].waste_line_id,
            };
            this.wastelines.push(obj);
          }
        }
      });
    },
    getInputType() {
      this.inputtypes = [];

      this.$http.get(":10001/api/v1/preprocessing/input").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].waste_type_id,
              label: response[i].name,
              quantity: response[i].quantity,
            };

            this.inputtypes.push(obj);
          }
        }
      });
    },
    download() {
      console.log("download");
    },
    print() {
      console.log("print");
    },
    addOutput() {
      this.outputs.push({
        id: this.outputs.length + 1,
        quantityProduced: "",
        outputType: "",
      });
    },
    // using
    getBack() {
      this.$router.push("/Preprocess");
    },
    done(flag) {
      if (flag == "output") {
        let output = [];
        for (var i = 0; i < this.outputs.length; i++) {
          let obj2 = {
            quantity: parseInt(this.outputs[i].quantityProduced),
            waste_type_id: this.outputs[i].outputtype,
          };
          output.push(obj2);
        }

        let obj = {
          output: output,
        };

        this.$http
          .post(
            ":10001/api/v1/preprocessing/" +
              this.preprocessingrefno +
              "/output",
            obj
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              this.message = response;
              this.modals.successModal = true;

              setTimeout(() => {
                this.$router.push("/Preprocess");
              }, 2000);
            }
          })
          .catch((err) => {
            this.message = err.response.data.message;
            this.modals.failedModal = true;
          });
        // console.log(flag);
      }

      if (flag == "create") {
        if (
          this.preprocessingrefno != "" &&
          this.inputtype != "" &&
          this.quantitytobeprocessed != "" &&
          this.wasteline != ""
        ) {
          this.errormsg = "";

          let obj = {};
          if (this.positionid == 1) {
            obj = {
              waste_type_id: this.inputtype,
              quantity: parseInt(this.quantitytobeprocessed),
              waste_line_id: this.wasteline,
              service_location_id: this.servicelocation,
            };
          } else {
            obj = {
              waste_type_id: this.inputtype,
              quantity: parseInt(this.quantitytobeprocessed),
              waste_line_id: this.wasteline,
            };
          }

          if (this.$route.params.action == "add") {
            this.$http
              .post(
                ":10001/api/v1/preprocessing/" + this.preprocessingrefno,
                obj
              )
              .then((res) => {
                if (!res.error) {
                  let response = res.message;
                  console.log(response);
                  this.modals.done = true;

                  setTimeout(() => {
                    this.$router.push("/Preprocess");
                  }, 2000);
                }
              })
              .catch((err) => {
                this.message = err.response.data.message;
                this.modals.failedModal = true;
              });
          }
        } else {
          console.log("heep");
          this.errormsg = "All data are required";
          console.log(this.errormsg);
        }
        // this.viewflag = "qr";
      }
    },
    getNext() {
      this.$router.push("/JobPage2");
    },
    // saveDraft() {
    //   console.log("save draft");
    // },
    onFileChange(event) {
      const t = event.target;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          this.selectedFileName = t.files[i].name;
          this.allfilename.push(this.selectedFileName);
        }
      } else {
        this.selectedFileName = "";
      }

      this.document = t.files.length;

      var input;

      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);
          this.docs = formData;

          this.$http
            .post(":10001/api/v1/upload/", this.docs, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log("data masuk", response);
                this.documentID.push(response.document_id);
              } else {
                console.log("data tak masuk");
              }
            });
        }
      }
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
        this.documentID.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },

    //land waste
    addWaste() {
      this.cardWasteCount++;
      this.wastes.push({ id: this.cardWasteCount });
    },
    getWasteTitle(index) {
      return `Waste - ${index + 1}`;
    },
    deleteWaste(index) {
      this.wastes.splice(index, 1);
    },
    deleteWasteById(wasteId, index) {
      const foundIndex = this.wastes.findIndex((waste) => waste.id === wasteId);
      if (foundIndex !== -1) {
        this.wastes.splice(foundIndex, 1);
        this.landphreading.splice(foundIndex, 1);
        this.landtemperature.splice(foundIndex, 1);
      } else {
        console.log("Vehicle not found with ID: ", wasteId);
      }
    },

    //vessel
    addWasteVessel() {
      this.cardWasteVesselCount++;
      this.wastesvessel.push({ id: this.cardWasteVesselCount });
    },
    getWasteVesselTitle(index) {
      return `Waste - ${index + 1}`;
    },
    deleteWasteVessel(index) {
      this.wastesvessel.splice(index, 1);
    },
    deleteWasteVesselById(wasteVesselId, index) {
      const foundIndex = this.wastesvessel.findIndex(
        (wastevessel) => wastevessel.id === wasteVesselId
      );
      if (foundIndex !== -1) {
        this.wastesvessel.splice(foundIndex, 1);
        this.vesselphreading.splice(foundIndex, 1);
        this.vesseltemperature.splice(foundIndex, 1);
      } else {
        console.log("Vehicle not found with ID: ", wasteVesselId);
      }
    },

    //vessel waste
  },

  computed: {},
  watch: {
    outputs: {
      handler(val) {
        this.errormsg = ""
        console.log(val);
        let maxQuantity = val.reduce((accumulator, currentValue) => {
          // currentValue.quantityProduced == ""
          let quantityProduce = 0;
          console.log(parseInt(currentValue.quantityProduced));

          if (parseInt(currentValue.quantityProduced) > 0) {
            quantityProduce = parseInt(currentValue.quantityProduced);
          }
          return (accumulator += quantityProduce);
        }, 0);

        this.showaddoutput = ( maxQuantity != this.quantitytobeprocessed ) ? false : true ;
        console.log(this.showaddoutput)

        if(maxQuantity < this.quantitytobeprocessed ){
          this.errormsg = "Cannot less than " + this.quantitytobeprocessed
          this.addoutputflag = true
        } else if (maxQuantity > this.quantitytobeprocessed ){
          this.errormsg = "Cannot exceed " + this.quantitytobeprocessed
          this.addoutputflag = false
        }
        
        // console.log(
        //   "maxQuantity: ",
        //   maxQuantity,
        //   ", quantity to be process: ",
        //   this.quantitytobeprocessed
        // );
        // console.log(this.showaddoutput);
      },
      deep: true,
    },
    inputtype() {
      console.log(this.inputtype);
    },
    inputtype() {
      console.log(this.outputtypes);

      for (var i = 0; i < this.inputtypes.length; i++) {
        if (this.inputtype == this.inputtypes[i].value) {
          this.totalqty = this.inputtypes[i].quantity;
        }
      }
    },
  },
};
</script>
<style>
.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

.scrollable {
  height: 600px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.card .card-header {
  text-transform: uppercase;
  font-weight: 600;
  padding-bottom: 10px;
  font-size: 18px;
}

.custom-dropdown .el-select-dropdown {
  /* Dropdown styles */
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-option {
  /* Option styles */
  color: #333;
  background-color: #fff;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

.scrollable-content {
  flex: 0 0 auto;
  white-space: nowrap;
  margin-right: 15px;
  /* Adjust as needed */
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

.subtitle {
  color: #A5A5A5 !important;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}
</style>
